import { metrics as pubhubMetrics } from "@riot-private/pubhub-sdk";
import {
  BLADE_COMPONENTS,
  createBladeRegistry,
  type Metrics,
} from "@riot-private/blades-ui";
import { reportSiteBuilderRumError } from "./rumErrorQueue";

/** Both the shared and retained legacy paths report only content-free errors. */
export const reportSiteBuilderBladeError: Metrics["noticeError"] = (
  _error,
  context,
) => {
  const phase = context?.phase === "validation" ? "validation" : "render";
  const safeError = new Error(`Blade ${phase} failed`);
  safeError.stack = undefined;
  const attributes: Record<string, string | number> = { phase };
  if (
    typeof context?.index === "number" &&
    Number.isSafeInteger(context.index) &&
    context.index >= 0
  ) {
    attributes.index = context.index;
  }
  // Revalidate canonical discriminators even when called directly by the legacy renderer.
  if (
    typeof context?.bladeType === "string" &&
    context.bladeType.length > 0 &&
    context.bladeType.length <= 128 &&
    Object.prototype.hasOwnProperty.call(BLADE_COMPONENTS, context.bladeType)
  ) {
    attributes.bladeType = context.bladeType;
  }
  if (
    typeof context?.bladeId === "string" &&
    context.bladeId.length > 0 &&
    context.bladeId.length <= 128
  ) {
    attributes.bladeId = context.bladeId;
  }
  if (context?.fallbackFailure === true) attributes.fallbackFailure = 1;
  if (typeof window === "undefined")
    console.error(safeError.message, attributes);
  try {
    pubhubMetrics.noticeError(safeError, attributes);
  } catch {
    // A failed SDK must not suppress the independent RUM report or the blade fallback.
  }
  reportSiteBuilderRumError(safeError, attributes);
};

export const createSiteBuilderBladeRegistry = () =>
  createBladeRegistry({
    metrics: { noticeError: reportSiteBuilderBladeError },
  });
